import Button from 'components/_parts/atoms/button';
import IconCustom from 'components/_parts/atoms/icon';
import { useState } from 'react';
import { createPortal } from 'react-dom';
import { Package } from 'react-feather';
import { useCompetencyImportMutation } from 'components/company/hooks/useCompany';
import styled from 'styled-components';
import { getXLSX } from 'helpers/xlsx';

const FullScreenOverlay = styled.div`
  position: fixed;
  height: 100%;
  width: 100%;
  right: 0;
  right: 0;
  top: 0;
`;

const Content = styled.div`
  width: 400px;
  height: 300px;
  background: white;
  border-radius: 20px;
  position: absolute;
  left: 50%;
  transform: translate(-50%, -50%);
  top: 50%;
  box-shadow: rgba(0, 0, 0, 0.24) 0px 3px 8px;
`;

const ImportIcon = styled(Package)`
  color: #3d5afe;
  cursor: pointer;
`;

function Index({ t }) {
  const competencyImportMutation = useCompetencyImportMutation();
  const unselected = t('company.unselected');
  const [tempFile, setTempFile] = useState();
  const [filename, setFilename] = useState(unselected);
  const [isShow, setIsShow] = useState(false);
  const uploadFile = (e) => {
    e.preventDefault();
    const { files } = e.target;
    const f = files[0];
    const reader = new FileReader();
    reader.onload = async function (e) {
      const XLSX = await getXLSX();
      const data = e.target.result;
      const wb = XLSX.read(data, { type: 'binary' });
      const sheetName = wb.SheetNames[0];
      const sheetValue = wb.Sheets[sheetName];
      const excelData = XLSX.utils.sheet_to_json(sheetValue);
      const newArr = excelData.map((val, i) => ({
        no: val.no,
        title: val.title,
        type: val.type,
        competency_type: val.competency_type,
        competency_level: val.competency_level,
        value: val.value,
        order: val.order,
      }));
      setTempFile({
        company_id: localStorage.getItem('company_id'),
        competencies: newArr,
      });
    };
    reader.readAsBinaryString(f);
    setFilename(f.name);
  };

  const submitFile = async () => {
    await competencyImportMutation.mutateAsync(tempFile);
    setIsShow(false);
    setFilename(unselected);
    setTempFile({});
  };
  return (
    <>
      <span onClick={() => setIsShow(true)}>
        <IconCustom
          typeIcon="setting"
          style={{
            marginLeft: '10px',
            cursor: 'pointer',
          }}
        />
      </span>
      {isShow
        && createPortal(
          <>
            <FullScreenOverlay
              className="cs_modal-bg"
              onClick={() => {
                setIsShow(false);
                setFilename(unselected);
                setTempFile({});
              }}
            />
            <Content className="p-3">
              <div className="w-100 h-100 d-flex justify-content-center align-items-center flex-column">
                <form className="dropzone">
                  <label htmlFor="upload">
                    <ImportIcon size={100} />
                  </label>
                  <input
                    name="file"
                    id="upload"
                    className="d-none"
                    type="file"
                    accept=".xlsx"
                    onChange={(e) => uploadFile(e)}
                  />
                </form>
                <div
                  className="pt-3 w-100 d-flex flex-column justify-content-center align-items-center"
                  style={{ columnGap: '20px' }}
                >
                  <div>
                    <span>
                      {t('company.filename')}
                      {' '}
                      :
                      {filename}
                    </span>
                  </div>
                  <Button
                    icon="create"
                    className="mt-2 px-4"
                    style={{ maxWidth: '120px' }}
                    func={() => {
                      submitFile();
                    }}
                  >
                    {t('board.submit')}
                  </Button>
                  <Button
                    className="mt-2 px-4"
                    style={{ maxWidth: '120px', backgroundColor: '#c8c87d' }}
                    func={() => (window.location.href = '/template_competency_lib.xlsx')}
                  >
                    {t('company.template')}
                  </Button>
                </div>
              </div>
            </Content>
          </>,
          document.getElementById('pop_up-parent'),
        )}
    </>
  );
}

export default Index;
